import React from 'react';

import { TextBlock } from '@components/TextBlock';

import {
  CIconContainer,
  CTextContainer,
  CharacteristicContainer,
} from './Characteristic.styled';

import { CharacteristicProps } from './Characteristic.types';

export const Characteristic = ({
  text,
  icon,
  textColor,
}: CharacteristicProps) => (
  <CharacteristicContainer>
    <CIconContainer textColor={textColor}>{icon}</CIconContainer>
    <CTextContainer>
      <TextBlock
        text={text}
        align="left"
        color={textColor}
        size={1.5}
        cursor="pointer"
      />
    </CTextContainer>
  </CharacteristicContainer>
);
